const state = {

    currencyRes: null,
    orgCurrencyRes: null,
    currencyFormatRes: null,
    orgCurrenciesDpOptions: null,
    orgCurrencies: null,
    agentCurrencies: null,

}

// getters
const getters = {

    GET_CURRENCY_RES: (state) => {
        return state.currencyRes;
    },
    GET_ORG_CURRENCY_RES: (state) => {
        return state.orgCurrencyRes;
    },
    GET_ORG_CURRENCY_DP_OPTIONS: (state) => {
        return state.orgCurrenciesDpOptions;
    },
    GET_ORG_CURRENCY_FORMAT_RES: (state) => {
        return state.currencyFormatRes;
    },

    GET_ORG_CURRENCIES: (state) => {
        return state.orgCurrencies
    },
    GET_AGENT_CURRENCIES: (state) => {
        return state.agentCurrencies;
    }
}

// actions
const actions = {
    CLEAR_CURRENCY_LIST_STORE({ commit }) {
        commit("clearcurrencylsStore");
    },
    SET_CURRENCY_RES({ commit }, res) {
        commit('getCurrencyRes', res);
    },
    SET_ORG_CURRENCY_RES({ commit }, res) {
        commit('getOrgCurrencyRes', res);
    },

    SET_ORG_CURRENCY_DP_OPTIONS({ commit }, res) {
        commit('saveCurrencyDpOptions', res);
    },

    SET_ORG_CURRENCY_FORMAT_RES({ commit }, res) {
        commit('getFormatCurrencyRes', res);
    },
    SET_ORG_CURRENCIES({ commit }, val) {
        commit('saveOrgCurrencies', val);
    },
    SET_AGENT_CURRENCIES({ commit }, agnt) {
        commit('saveAgentCurrencies', agnt);
    },

}

// mutations
const mutations = {
    clearcurrencylsStore(state) {
        state.currencyRes = null;
        state.orgCurrencyRes = null;
        state.currencyFormatRes = null
        state.orgCurrenciesDpOptions = null
        state.orgCurrencies = null,
        state.agentCurrencies = null
    },

    getCurrencyRes(state, res) {
        state.currencyRes = res
    },
    getOrgCurrencyRes(state, response) {
        state.orgCurrencyRes = response
    },

    getFormatCurrencyRes(state, resFormat) {
        state.currencyFormatRes = resFormat
    },



    saveCurrencyDpOptions(state, val) {
        state.orgCurrenciesDpOptions = val
    },
    saveOrgCurrencies(state, val) {
        state.orgCurrencies = val
    },
    saveAgentCurrencies(state, agnt) {
        state.agentCurrencies = agnt
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}